
import { useStore } from '@/store'
import { defineComponent, inject, onUnmounted, ref } from 'vue'
import { computed, watch } from 'vue'
import bagsizeSettings from '@/settings/bagsize-settings.json'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import FormOption from '@/components/Form/FormOption.vue'
import Analytics from '@/singletons/analytics'
import FormTab from '@/components/Abstract/FormTab.vue'

export default defineComponent({
  name: 'FormBody',
  components: {
    FormTab,
    FormOption
  },
  props: {
    index: Number
  },
  setup() {
    const store = useStore()
    const emitter: any = inject('emitter')
    const configBagsizeId = computed(() => store.getters.configBagsizeId)
    const options = computed(() => bagsizeSettings.bagsizeOptions)
    let currentSelection = ref()

    emitter.on('chooseMobileBagtype', onChooseMobileBagtype)

    // prettier-ignore
    watch(() => configBagsizeId.value, (config) => {
        currentSelection.value = bagsizeSettings.bagsizeOptions.find(x => x.id == config);
      }
    )

    const openBagtypeDialog = () => {
      emitter.emit('openBagtypeDialog')
    }

    function onChooseMobileBagtype(option: any) {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_BAGSIZE, option.id)
      Analytics.instance.sendBagsizeEvent(option.id)
    }

    onUnmounted(() => {
      emitter.off('chooseMobileBagtype', onChooseMobileBagtype)
    })

    return {
      configBagsizeId,
      bagsizeSettings,
      openBagtypeDialog,
      currentSelection,
      options,
    }
  }
})
